import React, { useEffect } from 'react';

import { Divider, Flex, useTheme } from '@chakra-ui/react';
import { Skeleton } from '@material-ui/lab';
import { components } from 'react-select';
import { FlexContainer, VerticallyAlignedFlexContainer } from 'styles/common';

import { ArrowRight } from 'assets/assetsV1/iconComponents';

import { sendClickedTopViewFilterEvent, sendLevelUpViewChangedEvent } from 'constants/mixpanelHelper';

import { Button } from 'uiToolkitV1/Button';
import { Chip } from 'uiToolkitV1/Chip';
import { Select } from 'uiToolkitV1/Select';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { LEVELUP_FILTERS_ARRAY } from '../constants';
import { useLevelUpPageContext } from '../context';

export const LevelUpRoleOption = ({ children, ...props }) => {
  const label = props?.value ? 'Future Role' : 'Current Role';
  return (
    <components.Option {...props}>
      <TextBodyMedium bold color="text.g1">
        {children}
      </TextBodyMedium>
      <TextLabel color="text.g2">{label}</TextLabel>
    </components.Option>
  );
};

const LevelUpFilters = () => {
  const {
    state: { levelUpDetails, isLoading, competencyFilters, functionAndRoleNotSet, isTargetRoleSelected },
    toggleCompetencyFilter,
    changeSelectedRole,
    openRoleSelectionModal,
    setAllCompetencyFilter,
  } = useLevelUpPageContext();
  const { competenciesGroupedByCompetencyStatus = {}, tableData } = levelUpDetails ?? {};

  const allCompetenciesCount = tableData?.competencies?.length ?? 0;

  // checking if all the filters are either false or true
  const isAllFilterSelected =
    Object.values(competencyFilters).every((v) => v === false) ||
    Object.values(competencyFilters).every((v) => v === true);

  useEffect(() => {
    // this to clear all filters when "All" is selected by selecting all the remaining
    // filters but "All"
    if (isAllFilterSelected) {
      setAllCompetencyFilter();
    }
  }, [isAllFilterSelected]);

  const chakraTheme = useTheme();

  const onFilterClick = (filterId) => {
    const isAllFilter = filterId === LEVELUP_FILTERS_ARRAY[0].id;
    // to not allow filters with 0 competencies to be clicked
    // if (!competenciesGroupedByCompetencyStatus[filterId]?.length && !isAllFilter) {
    //   return;
    // }

    sendClickedTopViewFilterEvent({
      eventProperties: {
        filter: LEVELUP_FILTERS_ARRAY?.find(({ id }) => id === filterId).display,
      },
    });
    if (isAllFilter) {
      setAllCompetencyFilter();
      return;
    }
    toggleCompetencyFilter(filterId);
  };

  const currentRole = levelUpDetails?.currentJobRole?.name ?? '';
  const nextRole = levelUpDetails?.targetJobRole?.name ?? '';

  const ChangeFutureRoleMenu = (props) => (
    <>
      <components.MenuList {...props}>{props.children}</components.MenuList>
      <Divider orientation="horizontal" color="neutral.CFD7DF" />
      <Button variant="tertiary" EndIcon={ArrowRight} onClick={openRoleSelectionModal}>
        {nextRole ? 'Change' : 'Select'} Future Role
      </Button>
    </>
  );

  const selectOptions = [
    {
      label: currentRole,
      value: false, // is target role ?
    },
    {
      label: nextRole,
      value: true,
    },
  ];

  const selectedOption = isTargetRoleSelected ? selectOptions[1] : selectOptions[0];

  if (levelUpDetails?.isShowWelcome) {
    return null;
  }

  return (
    <VerticallyAlignedFlexContainer style={{ padding: '12px' }}>
      <>
        {!functionAndRoleNotSet && (
          <VerticallyAlignedFlexContainer style={{ alignItems: 'center', height: '40px' }}>
            <TextBodyMedium sx={{ marginRight: '8px' }} bold color={chakraTheme.colors.text.g3}>
              Showing :
            </TextBodyMedium>
            {LEVELUP_FILTERS_ARRAY.map((filter, index) => {
              const isAllFilter = filter?.id === LEVELUP_FILTERS_ARRAY[0].id;
              return (
                <div
                  onClick={() => {
                    onFilterClick(filter.id);
                  }}
                >
                  <Chip
                    variant="outlined"
                    selected={isAllFilter ? isAllFilterSelected : competencyFilters[filter.id]}
                    sx={{ marginRight: '8px' }}
                  >
                    {isLoading ? (
                      <Skeleton width={80} />
                    ) : (
                      <>
                        {filter?.display} (
                        {isAllFilter
                          ? allCompetenciesCount
                          : (competenciesGroupedByCompetencyStatus[filter.id]?.length ?? 0)}
                        )
                      </>
                    )}
                  </Chip>
                </div>
              );
            })}
          </VerticallyAlignedFlexContainer>
        )}
        {(!isLoading || levelUpDetails?.currentJobRole?.name || levelUpDetails?.targetJobRole?.name) &&
          !functionAndRoleNotSet && (
            // nextRole &&
            <FlexContainer style={{ marginLeft: 'auto' }}>
              <VerticallyAlignedFlexContainer>
                <TextBodyMedium sx={{ marginRight: '4px' }} bold color="text.g3">
                  Current view:
                </TextBodyMedium>
                <Flex
                  style={{
                    width: '15rem',
                    zIndex: '5',
                  }}
                  sx={{
                    '.select': {
                      width: '100%',
                    },
                  }}
                >
                  <Select
                    options={nextRole ? selectOptions : [selectOptions[0]]} // shortcut for now, ideally we should use array filter
                    value={selectedOption}
                    isDisabled={selectOptions?.length < 2 || isLoading}
                    handleChange={(newValue) => {
                      sendLevelUpViewChangedEvent({
                        eventProperties: {
                          view: newValue.value ? 'Target Role' : 'Current Role',
                        },
                      });
                      changeSelectedRole({ isTargetRole: newValue.value });
                    }}
                    components={{
                      MenuList: ChangeFutureRoleMenu,
                      Option: LevelUpRoleOption,
                    }}
                    isSearchable={false}
                  />
                </Flex>
              </VerticallyAlignedFlexContainer>
            </FlexContainer>
          )}
      </>
    </VerticallyAlignedFlexContainer>
  );
};

export default LevelUpFilters;
